import { Duration } from 'luxon';

export const MAX_SPAN_TO_START_WORK_TIME = Duration.fromObject({ minutes: 30 });
